import { AxisBottom } from '@visx/axis';
import { Group } from '@visx/group';
import { AnyD3Scale } from '@visx/scale';
import { BarChartBottomAxisTicks } from '../BarChartBottomAxisTicks';

const labelOffset = -40;
const ticksOffset = 24;

export const XAxis = ({
    scale,
    height,
    marginLeft,
    marginBottom,
    isHorizontal,
    label,
    tickPositions,
    rotateTicks
}: {
    scale: AnyD3Scale;
    height: number;
    marginLeft: number;
    marginBottom: number;
    isHorizontal: boolean;
    label?: string;
    tickPositions?: { tick: string | number; xPosition: number; key: string }[];
    rotateTicks: boolean;
}) => (
    <>
        <AxisBottom
            top={height - marginBottom}
            left={marginLeft}
            scale={scale}
            stroke='var(--dividerTertiary)'
            tickValues={[]}
            hideAxisLine={isHorizontal}
            hideTicks
            label={label}
            labelOffset={marginBottom + labelOffset}
            labelClassName='fill-textSecondary'
            labelProps={{
                fontSize: 12,
                fontFamily: 'Inter',
                textAnchor: 'middle'
            }}
        />

        <Group top={height - marginBottom + ticksOffset} left={marginLeft}>
            {tickPositions?.map((t) => (
                <BarChartBottomAxisTicks key={t.key} tick={t.tick} xPosition={t.xPosition} rotateTicks={rotateTicks} />
            ))}
        </Group>
    </>
);
